import { communication } from '../../api/communication';
import { IframeWindow } from '.';

export class Communication implements communication.Api {
  constructor(private iframe: IframeWindow) {}

  composeEmail(request: communication.CreateEmailRequest): void {
    this.iframe.postMessage({
      command: 'communication.composeEmail',
      args: request,
    });
  }

  createAppointment(request: communication.CreateAppointmentRequest): void {
    this.iframe.postMessage({
      command: 'communication.createAppointment',
      args: request,
    });
  }

  createTask(request: communication.CreateTaskRequest): void {
    this.iframe.postMessage({
      command: 'communication.createTask',
      args: request,
    });
  }
}
